import type { ReactNode } from "react";
import type { MakerChain } from "../lib/api";
import type { Loaded } from "../lib/useLoad";
import { ChainDown, isChainDown, Loading, LoadError } from "./ui";

/**
 * A page's body for one network: the content once read; the network card when
 * the network does not answer (no stale values and no Set); another failure's
 * card; or the spinner while it loads.
 */
export function PageBody<T>({ load, chain, children }: { load: Loaded<T>; chain: MakerChain; children: (data: T) => ReactNode }) {
  if (load.error !== null && isChainDown(load.error)) return <ChainDown chain={chain} onRetry={load.reload} />;
  if (load.data !== null) return <>{children(load.data)}</>;
  if (load.error !== null) return <LoadError error={load.error} chain={chain} onRetry={load.reload} />;
  return <Loading />;
}

/** "Last read on BSC 12 Oct 09:31 UTC" while the network is down; undefined otherwise (the head's own words). */
export function downReadText(load: Loaded<unknown>, chain: MakerChain, readAt: number | null): string | undefined {
  if (load.error === null || !isChainDown(load.error)) return undefined;
  if (readAt === null) return "Not read yet";
  const d = new Date(readAt);
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const two = (n: number) => String(n).padStart(2, "0");
  return `Last read on ${chain.label} ${d.getUTCDate()} ${months[d.getUTCMonth()]} ${two(d.getUTCHours())}:${two(d.getUTCMinutes())} UTC`;
}
